import React from "react";
import axios from "axios";
import {apiUploadCsvUrl} from '../../requests/apiBaseUrls';
import {env} from "../../consts/env";
import { mutateData } from "../Service/graphQlService";
import { UPLOADCOSTAR_CSV } from "../Graphql/Mutations/uploadcostarcsvMutation";

export default class UploadCostarFile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            file: {
                name: null,
                file: null,
                message: '',
                invalidUpload: false
            },
            loading: false,
            submitted: false,
        };

        this.uploadFile = this.uploadFile.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.handleErrors = this.handleErrors.bind(this);
    }

    uploadFile() {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', '.csv');
        input.setAttribute('name', 'file');
        input.click();

        input.addEventListener('change', () => {
            const file = input.files[0];
            const reader = new FileReader();

            reader.addEventListener('load', event => {
                let uploadFileError = this.handleErrors(file.name);
                if (!uploadFileError) {
                    let encryption = event.target.result;
                    const index = encryption.indexOf('base64,') + 'base64,'.length;
                    encryption = encryption.replace(encryption.slice(0, index), '');
                    this.setState({
                        file: {
                            name: file.name,
                            file: encryption,
                            invalidUpload: false,
                        }
                    });
                } else {
                    this.setState({
                        file: {
                            name: null,
                            file: null,
                            message: uploadFileError,
                            invalidUpload: true,
                        }
                    });
                }
            });
            reader.readAsDataURL(file);
        });
    }

    removeFile() {
        this.setState({
            file: {
                name: null,
                file: null,
                message: ''
            }
        })
    }

    handleErrors(fileName) {
        return /(\.csv)$/i.test(fileName) ? null : 'Wrong file format! Supported file type: .csv';
    }

    async sendFile() {
        this.setState({loading: true});
        const file = this.state.file;
        const data = {
            fileName: file.name,
            encryption: file.file,
            testEnv: true
        };


       mutateData(UPLOADCOSTAR_CSV,data).then(res => {
            if (res.data.uploadCsv.success) {
                this.setState({
                    loading: false,
                    submitted: true,
                });
            } else {
                this.setState({
                    file: {
                        loading: false,
                        name: null,
                        file: null,
                        message: res.message ? res.message:  'Unspecified error',
                        invalidUpload: true,
                    }
                });
            }
        }, err => {
            this.setState({
                file: {
                    loading: false,
                    name: null,
                    file: null,
                    message:err.message ? err.message: 'Unspecified error',
                    invalidUpload: true,
                }
            });
        });
    }

    render() {
        const deleteIcon = `url("${arc.path.media}delete.svg")`;
        const {file, loading, submitted} = this.state;
        const readyToSubmit = file.file && !file.invalidUpload && !loading && !submitted;

        return (
            <div className='upload-file-container'>
                <div className='upload-file-title'>Upload .csv file</div>
                {
                    !file.file &&
                    <button type='button' className='button' onClick={() => this.uploadFile()}>Browse...</button>
                }
                <div className='upload-file-details'>
                    {
                        file.file && !loading && !submitted &&
                        <div className='upload-file-text'>{file.name}</div>
                    }
                    {
                        file.invalidUpload &&
                        <div className='upload-file-text' style={{color: `${file.invalidUpload ? '#FF5050' : ''}`}}>{file.message}</div>
                    }
                    {
                        file.file && !loading && !submitted &&
                        <div onClick={() => this.removeFile()} className='button delete' style={{backgroundImage: deleteIcon}}/>
                    }
                    {
                        file.file && loading &&
                        <div className='loading'/>
                    }
                </div>
                {
                    submitted &&
                    <div className='message'>File was successfully processed and the properties were added to iStrive!</div>
                }
                {
                    readyToSubmit &&
                    <button type='button' className='button submit' onClick={() => this.sendFile()}>Submit</button>
                }
            </div>
        );
    }
}